interface CurrencySetting {
    symbol: string;
    prefix: string;
}

interface AppSetting {
    currency: CurrencySetting;
    currencySystem: CurrencySetting;
}

const symbolCurrency = (): string => {
    let setting = localStorage.getItem("setting")
    if (setting === null) {
        return "€"
    }
    let settingJson = JSON.parse(setting) as AppSetting;
    return settingJson.currency.symbol
}

const prefixCurrency = (): string => {
    let setting = localStorage.getItem("setting")
    if (setting === null) {
        return "EUR"
    }
    let settingJson = JSON.parse(setting) as AppSetting;
    return settingJson.currency.prefix
}

const symbolCurrencySystem = (): string => {
    let setting = localStorage.getItem("setting")
    if (setting === null) {
        return "€"
    }
    let settingJson = JSON.parse(setting) as AppSetting;
    return settingJson.currencySystem.symbol
}

const prefixCurrencySystem = (): string => {
    let setting = localStorage.getItem("setting")
    if (setting === null) {
        return "EUR"
    }
    let settingJson = JSON.parse(setting) as AppSetting;
    return settingJson.currencySystem.prefix
}

const setting = (): AppSetting | null => {
    let setting = localStorage.getItem("setting")
    // JSON.parse(null) devolvia null por coercion a "null"; el guard explicito conserva
    // ese resultado sin depender de la coercion, que TS no acepta.
    return setting === null ? null : (JSON.parse(setting) as AppSetting);
}

const getUrlFile = (fileId: string, extension: string): string => {
    return  "/v1/cms/file/"+fileId + "/" + extension
}

export {
    symbolCurrency,
    prefixCurrency,
    symbolCurrencySystem,
    prefixCurrencySystem,
    getUrlFile
}
